"use client";

import { useTransition } from "react";
import { useRouter } from "next/navigation";
import { removeSavedRecipientAction } from "@/app/actions";

export default function RemoveButton({ id }: { id: number }) {
  const router = useRouter();
  const [pending, start] = useTransition();
  return (
    <button
      className="btn btn-ghost !px-4 !py-1.5 text-[13px]"
      disabled={pending}
      onClick={() =>
        start(async () => {
          await removeSavedRecipientAction(id);
          router.refresh();
        })
      }
    >
      Remove
    </button>
  );
}
